import {
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import ESigningRequestPreparingImageBuyer from 'assets/images/ESigningRequestPreparingImageBuyer.png';
import { poppins300 } from 'theme/common.style';
import CustomStepperAgent from '../CustomStepperAgent';
import FinalContractUploadDialog from 'component/BuyerRegistration/components/FinalContractUploadDialog';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom';
import { CONTRACT_FILE_UPLOAD } from 'constant/app.config';
import PrepareContractSignDialog from 'component/BuyerRegistration/components/PrepareContractSignDialog';
import { postApiCall } from 'api/apiService';

const Step1PrepareContractESign = (props) => {
  const { bannerDetails, isAgentDashboard } = props;

  const theme = useTheme();
  const params = useParams();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const [openPrepareDialog, setOpenPrepareDialog] = useState(false);
  const [openFinalContractDialog, setOpenFinalContractDialog] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadedContractUrl, setUploadedContractUrl] = useState(null);

  const handleOpenFinalContractDialog = () => {
    setOpenFinalContractDialog(true);
  };
  const handleCloseFinalContractDialog = () => {
    setOpenFinalContractDialog(false);
  };

  const handleFinalContractSubmit = async (file) => {
    setUploadedPdf(file);
    setOpenUploadDialog(false);
    setOpenPrepareDialog(true);
    try {
      const formData = new FormData();
      formData.append('propertyId', Number(bannerDetails?.propertyId));
      formData.append('vendorId', 0);
      formData.append('buyerId', bannerDetails?.isWinnerId);
      formData.append('contractFile', file);

      const response = await postApiCall(CONTRACT_FILE_UPLOAD, formData);
      if (response?.data?.status === 1) {
        setUploadedContractUrl(response.data.contractFile);
      }
    } catch (error) {}
  };

  const buyerName = bannerDetails?.winnerName;

  const handleClosePrepareDialog = () => {
    setOpenPrepareDialog(false);
  };

  const handleCloseAllContractDialogs = () => {
    setOpenPrepareDialog(false);
    setOpenFinalContractDialog(false);
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: 'rgba(33, 132, 253, 0.8)',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '0 0 10px 0' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container xs={12} md={12}>
          <Grid item container xs={12} md={9}>
            <Grid item xs={12}>
              <Stack
                direction={'column'}
                padding={matchessm ? '20px 20px 0 25px' : '30px 0 0 33px'}
              >
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: 300,
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  {bannerDetails?.propertyAddress}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '28px' : '16px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                    mt: matchessm ? 0.5 : 1,
                  }}
                >
                  {buyerName} has been nominated – Prepare Contract for
                  E-Signing!
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: matchessm ? 1 : 1.5,
                    color: '#FFF',
                  }}
                >
                  Prepare the Contract of Sale for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {bannerDetails?.propertyAddress}
                  </Typography>
                  &nbsp;and send the E-sign request to{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {buyerName}
                  </Typography>{' '}
                  now. Secure the buyer now.
                </Typography>
              </Stack>
            </Grid>
            <Grid item container xs={12} alignItems={'center'}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: 'flex',
                  justifyContent: matchessm ? 'space-between' : 'start',
                  gap: matchessm ? 1 : 2,
                  padding: matchessm ? '0 30px 0 30px' : '0 0 0 33px',
                }}
              >
                <Button
                  onClick={handleOpenFinalContractDialog}
                  sx={{
                    minWidth: matchessm ? 'auto' : '135px',
                    gap: matchessm ? '5px' : '10px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: '#FFFFFF',
                    color: '#2184FD',
                    '&:hover': {
                      bgcolor: '#FFFFFF',
                      color: '#2184FD',
                    },
                  }}
                >
                  Prepare Contract
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} alignItems={'center'}>
                <CustomStepperAgent stepValue={1} requestEsign={true} />
              </Grid>
            </Grid>
          </Grid>
          {!matchesmd && (
            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
              mt={2}
            >
              <img
                src={ESigningRequestPreparingImageBuyer}
                alt="ESigningRequestPreparingImageBuyer"
                style={{
                  objectFit: 'contain',
                  height: '257px',
                  width: '264px',
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
      {openFinalContractDialog && (
        <FinalContractUploadDialog
          open={openFinalContractDialog}
          onClose={handleCloseFinalContractDialog}
          onSubmit={handleFinalContractSubmit}
          streetName={bannerDetails?.propertyAddress}
          matchessm={matchessm}
          buyerId={bannerDetails?.isWinnerId}
          userType={'Agent'}
          propertyIdbanner={Number(bannerDetails?.propertyId)}
        />
      )}
      {openPrepareDialog && (
        <PrepareContractSignDialog
          open={openPrepareDialog}
          onCancel={handleClosePrepareDialog}
          onSuccess={handleCloseAllContractDialogs}
          pdfFile={uploadedPdf}
          streetName={bannerDetails?.propertyAddress}
          matchessm={matchessm}
          contractFileUrl={uploadedContractUrl}
          propertyId={Number(bannerDetails?.propertyId)}
          buyerId={bannerDetails?.isWinnerId}
          fromDashboard={true}
          userName={buyerName}
        />
      )}
    </>
  );
};

export default Step1PrepareContractESign;
